import React, { Component, useState } from "react";
// import "./LeaveApplicationHODFormEdit.css";
// import { Form,Button } from "react-bootstrap";
import { Form, Button, Col, Row } from "react-bootstrap";
// import axios from "axios";

export default function LeaveApplicationHODForm(props) {
  const [FromDateData, setFromDateData] = useState(props.editData["FromDate"].slice(0, 10));
  const [ToDateData, setToDateData] = useState(props.editData["ToDate"].slice(0, 10));
  const [ReasonforleaveData, setReasonforleaveData] = useState(props.editData["Reasonforleave"]);

  return (
    <div>
      <h2 id="role-form-title">
        Forward/Cancel Leave Application
      </h2>

      <div id="role-form-outer-div">
        <Form
          id="form"
          onSubmit={e =>
            props.onLeaveApplicationHODEditUpdate(props.editData, e, props.editData.data._id)
          }
        >
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Leave Type
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                type="Text"
                required
                disabled
                value={props.editData["Leavetype"]}
              />
            </Col>

          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              FromDate
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                type="date"
                required
                disabled
                value={FromDateData}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              ToDate
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                type="date"
                required
                disabled
                value={ToDateData}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Reason for leave
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                type="Text"
                placeholder="Reason for leave"
                required
                disabled
                value={ReasonforleaveData}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Leave Status
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control as="select" required>
                <option value="Pending" selected disabled>
                  Pending
                </option>
                <option
                  value="Forwarded"
                  selected={props.editData["Status"] === "Forwarded"}
                >
                  Forward
                </option>
                <option
                  value="Rejected"
                  selected={props.editData["Status"] === "Rejected"}
                >
                  Reject
                </option>
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row} id="form-submit-button">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button type="submit">Update</Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row} id="form-cancel-button">
            <Col sm={{ span: 10, offset: 2 }} id="form-cancel-button-inner">
              <Button type="reset" onClick={props.onFormEditClose}>
                cancel
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
}


